import { render, staticRenderFns } from "./WizardUserProfileStep.vue?vue&type=template&id=56b60f64&"
import script from "./WizardUserProfileStep.vue?vue&type=script&lang=js&"
export * from "./WizardUserProfileStep.vue?vue&type=script&lang=js&"
import style0 from "./WizardUserProfileStep.vue?vue&type=style&index=0&id=56b60f64&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b60f64')) {
      api.createRecord('56b60f64', component.options)
    } else {
      api.reload('56b60f64', component.options)
    }
    module.hot.accept("./WizardUserProfileStep.vue?vue&type=template&id=56b60f64&", function () {
      api.rerender('56b60f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardUserProfileStep.vue"
export default component.exports